import { overlayDebugLog } from '../helpers/overlayDebug'
import OverlayLayer from './OverlayLayer'
import Animate from './Animate'
import Parallax from './Parallax'
import FetchArt from './FetchArt'
import { initOverlaySlider } from './overlay/slider'
import { trapFocus } from './overlay/swiperA11y'
import {
  renderMiniHeader,
  setMiniHeaderTheme,
  syncPaginationBullets,
} from './overlay/headerMini'
import { createPlayerManager } from './overlay/playerManager'

class Overlay {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$links = [...document.querySelectorAll('.js-link')]
    this.ui.$stickyHeader = document.querySelector('.js-overlay-header-mini')
    this.ui.$audioPlayer = document.querySelector('.js-player')
    this.windowRef = window.location.href
    this.playerMgr = createPlayerManager()
    this._activeSlideCleanup = null
  }

  bindEvents() {
    this.ui.$links.forEach(element => {
      element.addEventListener('click', this.onClick.bind(this))
    })
  }

  onClick(e) {
    let target = e.currentTarget
    let delay
    if (!target.matches('.js-link')) return

    let ancestorId = target.getAttribute('data-parent-id')

    if (document.body.classList.contains('menu-is-open')) {
      window.menu[0].onClose()
    }

    if (target.classList.contains('js-link--home')) {
      target.querySelector('.thumbnail').classList.add('is-animate')
      delay = 1300
    } else {
      delay = 300
    }

    setTimeout(() => {
      window.overlaylayer = new OverlayLayer(ancestorId, target.hash)
      let slider = window.overlaylayer.ui.$overlay.querySelector('.js-slider')
      if (!slider) {
        overlayDebugLog('Overlay.onClick abort: slider introuvable', { ancestorId, hash: target.hash })
        return
      }
      
      if (window.sliderdefault) {
        window.sliderdefault.destroy()
        window.sliderdefault = undefined
        
      }
      const targetSlide = slider.querySelector('.swiper-slide' + target.hash)
      let activeIndex = Array.from(slider.querySelectorAll('.swiper-slide')).indexOf(targetSlide)
      if (activeIndex < 0) {
        activeIndex = 0
      }

      
      window.sliderdefault = initOverlaySlider(slider, {
        initialSlide: activeIndex,
        onActiveSlide: (slideEl) => {
          if (this._activeSlideCleanup) this._activeSlideCleanup()
          this._activeSlideCleanup = null

          this.playerMgr.moveInto(slideEl)

          const player = this.playerMgr.player
          const extraFocusable = player
            ? Array.from(
                player.querySelectorAll('.js-player-toggle, .js-player-transcript')
              )
            : []

          this._activeSlideCleanup = trapFocus(slideEl, {
            additionalFocusable: extraFocusable,
            onEscape: () => {
              slideEl.setAttribute('aria-hidden', 'true')
              window.overlaylayer.onClose(slideEl.querySelector('.js-overlay-close'))
            },
          })

          const originalOnClose = window.overlaylayer.onClose
          if (!window.overlaylayer.__overlayPlayerRestoreWrapped) {
            window.overlaylayer.__overlayPlayerRestoreWrapped = true
            window.overlaylayer.onClose = (...args) => {
              if (this._activeSlideCleanup) this._activeSlideCleanup()
              this._activeSlideCleanup = null
              this.playerMgr.restore()
              return originalOnClose.apply(window.overlaylayer, args)
            }
          }
        },
        swiperOptions: {
          observer: true,
          threshold: 20,
        },
      })

      window.sliderdefault.on('slideChange', function () {
        const activeIndex = this.activeIndex;
        const currentSlide = this.slides[activeIndex]
        const currentOverlayChild = currentSlide
          ? currentSlide.querySelector('.js-overlay-child')
          : null
        const currentSlideId = currentOverlayChild ? currentOverlayChild.getAttribute('data-id') : null
        let pathUrl;
        let overlayTitle = currentSlide ? currentSlide.querySelector('.js-overlay-title') : null
        window.fetchdata.items.forEach(item => {
          if (item.id == currentSlideId) {
            pathUrl = new URL(item.url)
          }
        });
        if (pathUrl && overlayTitle) {
          window.dataLayer.push({
            'event': 'page_view',
            'page_path': pathUrl.pathname,
            'page_title': overlayTitle.innerText
          });
        }
      });
      let hash = window.location.hash.substring(1)
      let slide = slider.querySelector('[data-hash="' + hash + '"]')
      if (!slide) {
        slide = slider.querySelector('.swiper-slide')
      }
      if (!slide) {
        overlayDebugLog('Overlay.onClick abort: slide introuvable', { ancestorId, hash })
        return
      }
      let index = slide.getAttribute('data-index')
      window.sliderdefault.activeIndex = parseInt(index)
      window.sliderdefault.realIndex = parseInt(index)
      window.sliderdefault.updateAutoHeight(300)
      let activeSlide = window.sliderdefault.slides[window.sliderdefault.activeIndex]
      window.sliderdefault.update()
      let overlayClose = activeSlide.querySelector('.js-overlay-close')
      let overlayTitle = activeSlide.querySelector('.js-overlay-title')
      let overlayPagination = activeSlide.querySelector('.js-pagination')

      const { close, title, pagination } = renderMiniHeader(this.ui.$stickyHeader, {
        closeEl: overlayClose,
        titleEl: overlayTitle,
        paginationEl: overlayPagination,
      })
      syncPaginationBullets(pagination, window.sliderdefault.activeIndex)



      let images = activeSlide.querySelectorAll('.js-parallax')
      if (images.length > 0) {
        window.parallax = new Parallax(images)
      }

      setMiniHeaderTheme(this.ui.$stickyHeader, activeSlide)

      window.animate = new Animate()

      let arts = [...activeSlide.querySelectorAll('.js-art-link')]
      if (arts.length > 0) {
        arts.forEach(element => {
          window.fetchart = new FetchArt(element, true)
        });
      }

      let id = activeSlide.querySelector('.js-overlay-child').getAttribute('data-id')
      let pathUrl

      window.fetchdata.items.forEach(item => {
        if (item.id == id) {
          pathUrl = new URL(item.url)
        }
      });

      if (pathUrl && title) {
        window.dataLayer.push({
          'event': 'page_view',
          'page_path': pathUrl.pathname,
          'page_title': title.innerText
        });
      }

      overlayDebugLog('Overlay.onClick → overlay:opened', {
        ancestorId,
        hash: target.hash,
        activeIndex: window.sliderdefault.activeIndex,
        slideId: id,
      })
      window.dispatchEvent(new CustomEvent('overlay:opened', { bubbles: true }))
    }, delay)
  }
}

export default Overlay;
